import type { ExceptionField } from '@/api/cockpit';

export function isQueueFieldEditable(field: ExceptionField, queueItemReadOnly: boolean): boolean {
  return field.editable && !queueItemReadOnly;
}
